import { svgIconClasses as n } from "@mui/material";
import { styled as a } from "./styled2.mjs";
const r = {
  blue: "info",
  green: "success",
  grey: "secondary",
  orange: "warning",
  red: "error",
  violet: "primary"
}, t = a("div")`
	display: inline-flex;
	align-items: center;
	flex-wrap: nowrap;
	gap: ${({ theme: e }) => e.spacing(0.5)};

	min-height: ${({ theme: e }) => e.spacing(2.25)};

	padding-inline: ${({ theme: e }) => e.spacing(0.5)};

	border: 1px solid;
	border-radius: ${({ theme: e }) => e.spacing(0.5)};
	border-color: ${({ theme: e, $color: i }) => e.palette[r[i]].main30};
	background: ${({ theme: e, $color: i }) => e.palette[r[i]].main};
	box-shadow: ${({ theme: e }) => e.tokens.shadow.xsmall};

	color: ${({ theme: e }) => e.palette.primary.contrast};
	white-space: nowrap;

	.${n.root} {
		width: ${({ theme: e }) => e.spacing(1.5)};
		height: ${({ theme: e }) => e.spacing(1.5)};
	}
`, p = a("div")`
	width: ${({ theme: e }) => e.spacing(1)};
	height: ${({ theme: e }) => e.spacing(1)};

	background: ${({ theme: e, $color: i }) => e.palette[r[i]].main};
	border-radius: 50%;
`;
export {
  t as Container,
  p as Dot
};
//# sourceMappingURL=styles13.mjs.map
